<template>
    <b-modal
        hide-footer
        size="xl"
        ref="imageViewer"
        id="image-viewers"
        modal-class="viewer-class"
    >
        <b-img
            class="shown-image"
            fluid
            :src="imageUrl"
            alt="ImageViewer"
        ></b-img>
    </b-modal>
</template>

<script type="text/javascript">
// This component rely heavily on css, refer to style for explanation
export default {
    data() {
        return {
            imageUrl: null
        };
    },
    methods: {
        open(imageUrl) {
            this.imageUrl = imageUrl;
            this.$refs.imageViewer.show();
        }
    }
};
</script>

<style scoped>
/* deep is require when overwriting global styling within style scoped */

/* width of modal follow image size */
/deep/ .viewer-class > .modal-dialog {
    max-width: fit-content;
}

/* hide modal UI by using instead visibility instead of display to avoid child from hidden also */
/deep/ .viewer-class > .modal-dialog > .modal-content {
    visibility: hidden;
}

/* re-set visibility of a child to visible instead of inherit from parent */
/deep/ .shown-image {
    visibility: visible;
    margin: auto;
    display: block;
    width: 100%;
    max-width: 700px;
}

/* Customize the Close Button */
/deep/ .close {
    visibility: visible;
    position: absolute !important;
    top: 25px;
    right: 0px;
    color: #f1f1f1 !important;
    padding: 0 !important;
}
</style>
